// extracted by mini-css-extract-plugin
module.exports = {"main":"LogoContainer_main__J9aYl"};